import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { UnderlineTabs } from 'components/FbUI/UnderlineTabs'
import { SavedFiltersTable } from 'features/settings/components/SavedFiltersTable'
import { TagTable } from 'features/settings/components/TagTable'
import { ColumnPresetsTable } from 'features/settings/components/ColumnPresetsTable'

type DataTab =
  | 'filters'
  | 'product-tags'
  | 'contact-tags'
  | 'document-tags'
  | 'deal-tags'
  | 'columns'

const DEFAULT_TAB: DataTab = 'filters'

const tabs: { key: DataTab; title: string }[] = [
  { key: 'filters', title: 'Filters' },
  { key: 'product-tags', title: 'Tags' },
  { key: 'contact-tags', title: 'Contact Labels' },
  { key: 'document-tags', title: 'Document Tags' },
  { key: 'deal-tags', title: 'Deal Tags' },
  { key: 'columns', title: 'Column Presets' },
]

const validTabs = new Set(tabs.map((t) => t.key))

export function DataSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = (params.tab as DataTab) ?? DEFAULT_TAB

  if (params.tab && !validTabs.has(params.tab as DataTab)) {
    return <Navigate to={`/settings/data/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0 bg-[#fefefe]">
      <FBPageInnerTabsContainer>
        <UnderlineTabs<DataTab>
          tabs={tabs}
          activeKey={tab}
          onChange={(value) => navigate(`/settings/data/${value}`)}
          idPrefix="data-settings"
          aria-label="Data settings tabs"
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer className="bg-[#fefefe]" hide={tab !== 'filters'}>
        <SavedFiltersTable />
      </FBPageTableContainer>
      <FBPageTableContainer
        className="bg-[#fefefe]"
        hide={tab !== 'product-tags'}
      >
        <TagTable tagParent="products" />
      </FBPageTableContainer>
      <FBPageTableContainer
        className="bg-[#fefefe]"
        hide={tab !== 'contact-tags'}
      >
        <TagTable tagParent="contacts" />
      </FBPageTableContainer>
      <FBPageTableContainer
        className="bg-[#fefefe]"
        hide={tab !== 'document-tags'}
      >
        <TagTable tagParent="documents" />
      </FBPageTableContainer>
      <FBPageTableContainer className="bg-[#fefefe]" hide={tab !== 'deal-tags'}>
        <TagTable tagParent="deals" />
      </FBPageTableContainer>
      <FBPageTableContainer className="bg-[#fefefe]" hide={tab !== 'columns'}>
        <ColumnPresetsTable />
      </FBPageTableContainer>
    </div>
  )
}
